/* istanbul ignore file */
import React from 'react';
import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';
import { SxProps, Theme } from '@mui/system';
import { TooltipLayoutProps } from 'framework/ui/uiContract';

export enum TooltipSize {
  BIG = 'big',
  DEFAULT = 'default',
}

export interface TooltipProps extends MuiTooltipProps {
  size?: TooltipSize;
}

const baseTooltipSx: SxProps<Theme> = {
  backgroundColor: 'var(--mui-palette-common-tooltipBg)',
  color: 'var(--mui-palette-text-primary)',
  fontSize: '12px',
  fontWeight: 400,
  padding: '10px',

  ul: {
    margin: '5px 0',
    paddingLeft: '15px',

    li: {
      '&:not(:last-child)': {
        marginBottom: '5px',
      },
    },
  },

  p: {
    margin: 0,

    '&:not(:last-child)': {
      marginBottom: '5px',
    },
  },

  a: {
    marginLeft: '4px',
    fontSize: '12px',
  },

  '.field__wrapper': {
    display: 'inline-flex',
  },
};

const popperSx: SxProps<Theme> = {
  '&[data-popper-placement*="top"] .MuiTooltip-tooltip': {
    marginBottom: '10px',
    marginLeft: '13px',
    marginRight: '13px',
  },

  '&[data-popper-placement*="bottom"] .MuiTooltip-tooltip': {
    marginTop: '10px',
    marginLeft: '13px',
    marginRight: '13px',
  },

  '&[data-popper-placement*="right"] .MuiTooltip-tooltip': {
    marginLeft: '13px',
  },

  '&[data-popper-placement*="left"] .MuiTooltip-tooltip': {
    marginRight: '13px',
  },
};

const largeTooltipSx: SxProps<Theme> = {
  maxWidth: '500px',

  '@media (max-width: 767px)': {
    maxWidth: 'calc(100% - 26px)',
  },
};

const Tooltip = (props: TooltipProps | TooltipLayoutProps) => {
  const {
    size = TooltipSize.DEFAULT,
    sx,
    ...tooltipProps
  } = {
    ...props,
    size: 'size' in props ? props.size : undefined,
    sx: 'sx' in props ? props.sx : undefined,
  };

  return (
    <MuiTooltip
      arrow
      {...tooltipProps}
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            ...baseTooltipSx,
            ...(size === TooltipSize.BIG ? largeTooltipSx : {}),
          },
        },
        arrow: {
          sx: {
            color: 'var(--mui-palette-common-tooltipBg)',
          },
        },
        popper: {
          sx: {
            ...popperSx,
            ...sx,
          },
        },
      }}
      PopperProps={{
        popperOptions: {
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['left', 'bottom', 'top'],
                boundary: 'window',
              },
            },
          ],
        },
      }}
    />
  );
};

export default Tooltip;
